import { Item, Items } from './item.model';
import * as firebase from 'firebase/app';
import 'firebase/firestore';

/* tslint:disable:max-line-length */

export function getTestItems(): Item[] {
  return [
    {
      id: '1234',
      title: 'I learned to READ my dreams (and you can too)',
      type: Items.Type.ARTICLE,
      description: 'British model Victoria Aitken said her dreams had always been /\'intense\' but she \'never used to pay them much heed\'. Then, she realised \'they were telling her about the issues she faced in her  life\'.',
      imageUrl: 'https://i.dailymail.co.uk/1s/2019/08/28/21/17803628-0-image-a-131_1567024609120.jpg',
      createdAt: new firebase.firestore.Timestamp(1581295865, 196000000),
      modifiedAt: new firebase.firestore.Timestamp(1581295865, 196000000),
      organizationId: '123',
      publishedAt: '2020-01-31T20:32:09.122Z',
      category: 'HR',
      sendPush: false,
      targetProfileTypes: {
        user: true
      },
      groups: ['HR', 'admin'],
    }, {
      id: '1235',
      title: 'Square Crypto Praises Gimmicky Bitcoin Giveaways but Doesn\'t Give Any Away',
      type: Items.Type.ARTICLE,
      description: 'Square Crypto, the cryptocurrency unit of Jack Dorsey\'s mobile-payment company Square, extolled the virtues of gimmicky bitcoin giveaways. But then it didn\'t offer to give any away. What a crypto tease! Do bitcoin giveaways promote adoption? Basically, Squareâ¦',
      imageUrl: 'https://www.ccn.com/wp-content/uploads/2019/08/bitcoin-giveaway-ss.jpg',
      createdAt: new firebase.firestore.Timestamp(1581295865, 196000000),
      modifiedAt: new firebase.firestore.Timestamp(1581295865, 196000000),
      organizationId: '123',
      publishedAt: '2020-02-01T20:32:09.122Z',
      category: 'HR',
      sendPush: false,
      targetProfileTypes: {
        user: true
      },
      groups: ['HR', 'admin'],
    }
  ];
}
